'use client'

import { useEffect, useState } from 'react'
import { CDP_SECTIONS } from '@/app/constants/cdpSections'

export default function PopupProgressNav() {
  const [activeIndex, setActiveIndex] = useState(0)


  useEffect(() => {
    const observers: IntersectionObserver[] = []

    CDP_SECTIONS.forEach((section, index) => {
      const el = document.getElementById(section.id)
      if (!el) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveIndex(index)
          }
        },
        {
          rootMargin: '-50% 0px -50% 0px',
          threshold: 0,
        }
      )
      observer.observe(el)
      observers.push(observer)
    })

    return () => observers.forEach(o => o.disconnect())

  }, [])

  return (
    <div className="relative flex flex-col gap-4 text-left">
      {/* Vertical line */}
      <div className="absolute left-2 top-0 h-full w-[2px]">
        <div
          className="w-full transition-all duration-300"
          style={{
            height: `${(activeIndex / (CDP_SECTIONS.length - 1)) * 100
              }%`,
          }}
        />
      </div>

      {CDP_SECTIONS.map((section, index) => {
        const isActive = index === activeIndex

        return (
          <button
            key={section.id}
            onClick={() =>
              document
                .getElementById(section.id)
                ?.scrollIntoView({ behavior: 'smooth' })
            }
            className="flex items-center gap-3"
          >
            <span className="relative flex items-center justify-center">
              {isActive ? (
                <>
                  <span className="h-5 w-5 rounded-full border-2 border-[#37DED7]" />
                  <span className="absolute h-2.5 w-2.5 rounded-full bg-[#37DED7]" />
                </>
              ) : (
                <span className="h-3 w-3 rounded-full bg-[#37DED7] ml-1" />
              )}
            </span>
            <span
              className={`text-sm text-[#37DED7] ${isActive
                  ? 'font-bold'
                  : 'font-medium'
                }`}
            >
              {section.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}
